/**
@license
Copyright (c) 2018 The Polymer Project Authors. All rights reserved.
This code may only be used under the BSD style license found at http://polymer.github.io/LICENSE.txt
The complete set of authors may be found at http://polymer.github.io/AUTHORS.txt
The complete set of contributors may be found at http://polymer.github.io/CONTRIBUTORS.txt
Code distributed by Google as part of the polymer project is also
subject to an additional IP rights grant found at http://polymer.github.io/PATENTS.txt
*/
import { UPDATE_PAGE, UPDATE_OFFLINE, OPEN_SNACKBAR, CLOSE_SNACKBAR, UPDATE_DRAWER_STATE, FIREBASE_INITIALIZE, FIREBASE_AUTH_INITIALIZE, FIREBASE_AUTHORIZE, FIREBASE_SIGNOUT, FIREBASE_FIRESTORE, LOAD_ORGANIZATIONS, organizationsLoaded, ORGANIZATIONS_LOADED, LOAD_JOBS, jobsLoaded, JOBS_LOADED, LOAD_JOBTYPES, jobTypesLoaded, JOBTYPES_LOADED, LOAD_BACKGROUNDSETS, backgroundSetsLoaded, BACKGROUNDSETS_LOADED, LOAD_BACKGROUNDS, BACKGROUNDS_LOADED, backgroundsLoaded, COMPANY_LOADED, VENDOR_LOADED, PERSON_LOADED, JOB_GET, loadJobs } from '../actions/app.js';
import { store } from '../store.js';
import { collection, onSnapshot, where, query, getDoc, doc } from 'firebase/firestore';
import { getAuth, signOut } from 'firebase/auth';
import { organizationConverter } from '../components/objects/organization.js';
import { backgroundConverter } from '../components/objects/orders.js';
export const YEARS = [
    "27-28",
    "26-27",
    "25-26",
    "24-25",
    "23-24",
    "22-23",
    "21-22",
    "20-21",
    "19-20",
    "18-19",
    "17-18",
    "16-17",
    "15-16"
];
const INITIAL_STATE = {
    page: '',
    offline: false,
    drawerOpened: false,
    snackbarOpened: false,
    isInitialized: false,
    firebase: undefined,
    isAuthInitializing: false,
    user: undefined,
    userDoc: undefined,
    personDoc: undefined,
    companyDoc: undefined,
    vendorDoc: undefined,
    year: "26-27",
    firestore: undefined,
    organizations: [],
    organization: undefined,
    jobs: [],
    jobDocId: undefined,
    jobTypes: [],
    backgroundSets: [],
    backgrounds: [],
    forcePasswordChange: false
};
const app = (state = INITIAL_STATE, action) => {
    switch (action.type) {
        case UPDATE_PAGE:
            return {
                ...state,
                page: action.page
            };
        case UPDATE_OFFLINE:
            return {
                ...state,
                offline: action.offline
            };
        case UPDATE_DRAWER_STATE:
            return {
                ...state,
                drawerOpened: action.opened
            };
        case OPEN_SNACKBAR:
            return {
                ...state,
                snackbarOpened: true
            };
        case CLOSE_SNACKBAR:
            return {
                ...state,
                snackbarOpened: false
            };
        case FIREBASE_INITIALIZE:
            return {
                ...state,
                firebase: action.firebase,
                firestore: action.firestore
            };
        case FIREBASE_AUTH_INITIALIZE:
            return {
                ...state,
                isAuthInitializing: true
            };
        case FIREBASE_AUTHORIZE:
            return {
                ...state,
                user: action.user,
                isInitialized: (state.isAuthInitializing && !action.user) || !!action.forcePasswordChange,
                isAuthInitializing: false,
                forcePasswordChange: action.forcePasswordChange || false
            };
        case FIREBASE_SIGNOUT:
            const auth = getAuth();
            signOut(auth);
            return {
                ...state,
                user: undefined,
                page: 'login',
                forcePasswordChange: false
            };
        case COMPANY_LOADED:
            window.company = action.companyDoc;
            return {
                ...state,
                companyDoc: action.companyDoc,
                isInitialized: action.companyDoc.get("active") === undefined || action.companyDoc.get("active") ? true : false
            };
        case VENDOR_LOADED:
            return {
                ...state,
                vendorDoc: action.vendorDoc,
                isInitialized: true
            };
        case PERSON_LOADED:
            //@ts-ignore
            window.person = action.personDoc;
            return {
                ...state,
                personDoc: action.personDoc
            };
        case FIREBASE_FIRESTORE:
            return {
                ...state,
                firestore: action.userDoc.ref.firestore,
                userDoc: action.userDoc
            };
        case LOAD_ORGANIZATIONS:
            if (action.companyRef && (!state.organizations || state.organizations.length === 0)) {
                const colRef = collection(action.companyRef, "Organizations").withConverter(organizationConverter);
                onSnapshot(colRef, (orgsSnapshot) => {
                    orgsSnapshot.docChanges().forEach((orgDocChange) => {
                        const o = orgDocChange.doc;
                        // @ts-ignore
                        //o.name = orgDocChange.doc.data().name;
                        switch (orgDocChange.type) {
                            case 'added':
                                state.organizations.splice(orgDocChange.newIndex, 0, o);
                                break;
                            case 'modified':
                                if (orgDocChange.newIndex != orgDocChange.oldIndex) {
                                    state.organizations.splice(orgDocChange.oldIndex, 1);
                                    state.organizations.splice(orgDocChange.newIndex, 0, o);
                                }
                                else {
                                    state.organizations.splice(orgDocChange.oldIndex, 1, o);
                                }
                                break;
                            case 'removed':
                                state.organizations.splice(orgDocChange.oldIndex, 1);
                                break;
                        }
                    });
                    store.dispatch(organizationsLoaded(state.organizations));
                    store.dispatch(loadJobs(state.year));
                });
            }
            return {
                ...state
            };
        case ORGANIZATIONS_LOADED:
            return {
                ...state,
                organizations: action.organizations
            };
        case LOAD_JOBS:
            if (state.companyDoc && action.year && (!state.jobs || state.jobs.length === 0)) {
                const colRef = collection(state.companyDoc.ref, "Jobs");
                onSnapshot(query(colRef, where("year", "==", action.year)), (jobsSnapshot) => {
                    jobsSnapshot.docChanges().forEach((jobDocChange) => {
                        const o = jobDocChange.doc;
                        // @ts-ignore
                        //o.name = orgDocChange.doc.data().name;
                        switch (jobDocChange.type) {
                            case 'added':
                                state.jobs.splice(jobDocChange.newIndex, 0, o);
                                break;
                            case 'modified':
                                if (jobDocChange.newIndex != jobDocChange.oldIndex) {
                                    state.jobs.splice(jobDocChange.oldIndex, 1);
                                    state.jobs.splice(jobDocChange.newIndex, 0, o);
                                }
                                else {
                                    state.jobs.splice(jobDocChange.oldIndex, 1, o);
                                }
                                break;
                            case 'removed':
                                state.jobs.splice(jobDocChange.oldIndex, 1);
                                break;
                        }
                    });
                    store.dispatch(jobsLoaded(state.jobs));
                });
            }
            return {
                ...state
            };
        case JOBS_LOADED:
            return {
                ...state,
                jobs: action.jobs
            };
        case JOB_GET:
            var j = state.jobs.find((job) => job.id === action.jobId);
            if (!j) {
                getDoc(doc(collection(state.companyDoc.ref, "Jobs"), action.jobId)).then((d) => {
                    if (d.exists())
                        j = d;
                });
            }
            return {
                ...state,
                job: j
            };
        case LOAD_JOBTYPES:
            if (state.firestore && (!state.jobTypes || state.jobTypes.length === 0)) {
                onSnapshot(collection(state.firestore, state.companyDoc.ref.path, "JobTypes"), (jobTypesSnapshot) => {
                    const updatedJobTypes = [...(state.jobTypes || [])];
                    jobTypesSnapshot.docChanges().forEach((jobTypeDocChange) => {
                        const o = jobTypeDocChange.doc;
                        switch (jobTypeDocChange.type) {
                            case 'added':
                                updatedJobTypes.splice(jobTypeDocChange.newIndex, 0, o);
                                break;
                            case 'modified':
                                if (jobTypeDocChange.newIndex != jobTypeDocChange.oldIndex) {
                                    updatedJobTypes.splice(jobTypeDocChange.oldIndex, 1);
                                    updatedJobTypes.splice(jobTypeDocChange.newIndex, 0, o);
                                }
                                else {
                                    updatedJobTypes.splice(jobTypeDocChange.oldIndex, 1, o);
                                }
                                break;
                        }
                    });
                    state.jobTypes = updatedJobTypes;
                    store.dispatch(jobTypesLoaded([...updatedJobTypes]));
                });
            }
            return {
                ...state
            };
        case JOBTYPES_LOADED:
            return {
                ...state,
                jobTypes: action.jobTypes
            };
        case LOAD_BACKGROUNDSETS:
            if (state.firestore && (!state.backgroundSets || state.backgroundSets.length === 0)) {
                onSnapshot(collection(state.firestore, state.companyDoc.ref.path, "BackgroundSets"), (backgroundSetsSnapshot) => {
                    backgroundSetsSnapshot.docChanges().forEach((backgroundSetDocChange) => {
                        const o = backgroundSetDocChange.doc;
                        switch (backgroundSetDocChange.type) {
                            case 'added':
                                state.backgroundSets.splice(backgroundSetDocChange.newIndex, 0, o);
                                break;
                            case 'modified':
                                if (backgroundSetDocChange.newIndex != backgroundSetDocChange.oldIndex) {
                                    state.backgroundSets.splice(backgroundSetDocChange.oldIndex, 1);
                                    state.backgroundSets.splice(backgroundSetDocChange.newIndex, 0, o);
                                }
                                else {
                                    state.backgroundSets.splice(backgroundSetDocChange.oldIndex, 1, o);
                                }
                                break;
                            case 'removed':
                                state.backgroundSets.splice(backgroundSetDocChange.oldIndex, 1);
                                break;
                        }
                    });
                    store.dispatch(backgroundSetsLoaded(state.backgroundSets));
                });
            }
            return {
                ...state
            };
        case BACKGROUNDSETS_LOADED:
            action.backgroundSets.sort((a, b) => {
                if (a.data().name < b.data().name)
                    return -1;
                if (a.data().name > b.data().name)
                    return 1;
                return 0;
            });
            return {
                ...state,
                backgroundSets: action.backgroundSets
            };
        case LOAD_BACKGROUNDS:
            if (state.firestore && action.backgroundSetRef) {
                const colRef = collection(state.firestore, state.companyDoc.ref.path, "Backgrounds").withConverter(backgroundConverter);
                onSnapshot(query(colRef, where("backgroundSet", "==", action.backgroundSetRef)), (backgroundsSnapshot) => {
                    const backgrounds = backgroundsSnapshot.docs;
                    store.dispatch(backgroundsLoaded(backgrounds));
                });
            }
            return {
                ...state
            };
        case BACKGROUNDS_LOADED:
            return {
                ...state,
                backgrounds: action.backgrounds
            };
        default:
            return state;
    }
};
export default app;
